module.exports = __webpack_public_path__ + "static/media/ExamAndProfile.c978f735.svg";